<template>
  <div class="templateQuickMenu">
    <li class="quick-manu-list logo">
      <i class="icon menu-icon" @click="close"></i>
      <!-- <a target="_blank" href="/templates">
        <img src="../../../../static/svg/laihua-logo-light.svg" alt="logo" />
      </a> -->
    </li>
    <li class="quick-manu-list file">
      <i class="icon file-icon"></i>
      <span>
        <a href="/manage" target="_blank">作品管理</a>
      </span>
    </li>
    <li class="quick-manu-list new">
      <i class="icon new-icon"></i>
      <span @click.stop="addNewDraft">新建</span>
    </li>
    <li class="quick-manu-list template">
      <i class="icon template-icon"></i>
      <span>
        <a href="/templates" target="_blank">模板</a>
      </span>
    </li>
    <li class="quick-manu-list story">
      <i class="icon story-icon"></i>
      <span>
        <a href="/templates?type=1" target="_blank">故事板</a>
      </span>
    </li>
    <li class="quick-manu-list vip">
      <i class="icon vip-icon"></i>
      <span>
        <a href="/vip" target="_blank">会员服务</a>
      </span>
    </li>
    <li class="quick-manu-list toggle-tips">
      <span>新手提示</span>
      <el-tooltip
        effect="dark"
        placement="bottom"
        :open-delay="1000"
        :width="200"
      >
        <div style="width: 200px; font-size: 14px" slot="content">
          开启新手模式，我们会在创作过程中对难度较高的功能进行较为详细的提示。若关闭，则我们会在操作中做较为简要的提示。开启或关闭均不会影响您的创作。
        </div>
        <i class="icon question-icon">?</i>
      </el-tooltip>
      <el-switch
        v-model="showTips"
        active-color="#aba7c2"
        inactive-color="#575075"
      ></el-switch>
    </li>
    <transition name="bounceInLeft">
      <div class="switch-tips-popover" v-show="!known">
        <div class="notice">
          <p class="title">点击这里可以关闭或开启新手提示</p>
          <p class="popover-content">
            （新手提示会在每一步操作时进行较为详细的提示，帮助你快速搞定动画）
          </p>
        </div>
        <div class="bottom-arrow"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "templateQuickMenu",
  data() {
    return {
      showTips: true,
      known: true,
    };
  },
  props: {},
  components: {},
  methods: {
    close() {
      this.$emit("close");
    },
    addNewDraft() {
      this.$http
        .get("/api/user/limit?type=draft")
        .then((res) => {
          console.log("res", res);
          if (res.data.data.exceed) {
            this.$memberGuide({
              show: true,
              isSubtitle: true,
              context: this,
              funcRight: {
                type: "draftNumber",
                name: "草稿数量",
              },
            });
          } else {
            window.open("/tool", "_blank");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  watch: {
    showTips(val, oldVal) {
      this.$bus.emit("switchTips", val);
      if (val) {
        window.localStorage.setItem("showTips", "show");
      } else {
        window.localStorage.setItem("showTips", "hide");
      }
    },
  },
  mounted() {
    if (
      window.localStorage.getItem("showTips") &&
      window.localStorage.getItem("showTips") === "hide"
    ) {
      this.showTips = false;
    } else {
      this.showTips = true;
    }
  },
  computed: {},
};
</script>

<style scoped lang='scss'>
.templateQuickMenu {
  position: relative;
  width: 220px;
  height: 100%;
  background-color: #474261;

  .quick-manu-list {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 60px;
    border-top: 2px solid #393451;
    .icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #474261;
      background-color: #fff;
      font-style: normal;
      margin-left: 21px;
    }
    span {
      color: #fff;
      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
  .logo:hover,
  .file:hover,
  .new:hover,
  .template:hover,
  .story:hover,
  .vip:hover {
    span {
      opacity: 0.7;
    }
  }
  .logo {
    border: none;
    .menu-icon {
      display: inline-block;
      width: 24px;
      height: 27px;
      background-color: #fff;
      cursor: pointer;
      margin-right: 37px;
      background: url("../../../../static/svg/menu-white.svg") no-repeat center;
      &:hover {
        background: url("../../../../static/svg/menu-active.svg") no-repeat
          center;
      }
    }
    img {
      width: 64px;
      height: 18px;
    }
  }
  .file {
    cursor: pointer;
    .file-icon {
      width: 18px;
      height: 16px;
      background: url("../../../../static/svg/works.svg") no-repeat center;
    }
    span {
      margin-left: 41px;
    }
  }
  .new {
    cursor: pointer;
    .new-icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: url("../../../../static/svg/add-new.svg") no-repeat center;
    }
    span {
      margin-left: 39px;
    }
  }
  .template {
    cursor: pointer;
    .template-icon {
      width: 20px;
      height: 20px;
      background: url("../../../../static/svg/template.svg") no-repeat center;
    }
    span {
      margin-left: 39px;
    }
  }
  .story {
    cursor: pointer;
    .story-icon {
      width: 20px;
      height: 18px;
      background: url("../../../../static/svg/story.svg") no-repeat center;
    }
    span {
      margin-left: 39px;
    }
  }
  .vip {
    cursor: pointer;
    .vip-icon {
      width: 24px;
      height: 18px;
      font-size: 12px;
      font-weight: bold;
      background: url("../../../../static/svg/vip.svg") no-repeat center;
    }
    span {
      margin-left: 35px;
    }
  }
  .toggle-tips {
    position: absolute;
    bottom: 0;
    left: 0;
    span:first-child {
      margin-left: 21px;
    }
    .question-icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fff;
      font-style: normal;
      margin-left: 12px;
      margin-right: 49px;
      cursor: pointer;
      &:hover {
        background-color: #8983a5;
      }
    }
    .el-switch__core:after {
      background-color: #8983a5;
    }
    .is-checked {
      .el-switch__core:after {
        background-color: #fff;
      }
    }
  }
  .switch-tips-popover {
    position: absolute;
    bottom: 63px;
    left: 137px;
    width: 280px;
    height: 140px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);
    border: solid 1px #dcdaf4;
    border-radius: 8px;
    padding: 25px 34px 20px 30px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .notice {
      text-align: left;
      font-size: 14px;
      color: #474261;
      .title {
        font-weight: bold;
        margin-bottom: 14px;
      }
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 36px;
      background-color: #5778fb;
      border-radius: 8px;
      color: #fff;
      margin-top: 26px;
      cursor: pointer;
    }
    .bottom-arrow {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      bottom: -11px;
      left: 27px;
      margin-bottom: 3px;
      border-width: 11px;
      border-bottom-width: 0;
      border-top-color: #fff;
      &::after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        right: -11px;
        bottom: -12px;
        margin-left: -5px;
        border-bottom-width: 0;
        border-top-color: #fff;
        // content: " ";
        border-width: 11px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/quickMenu/templateQuickMenu.vue